import ReactSwitch from 'react-switch';
import BootstrapSpinner from 'react-bootstrap/Spinner';
import { useSelector } from 'react-redux';
import { getShouldUseAttestation } from '../../../../growthbook';
import { useDentistBenevisAttestationToggle } from '../hooks/useDentistBenevisAttestationToggle';
import { AttestationCode } from '../../../../constants';

export const DentistAttestationCard = ({ officeId }) => {
  const currentUser = useSelector((state) => state.users.currentUser);
  const { isEnabled, isLoading, onToggle } = useDentistBenevisAttestationToggle(officeId);

  if (!getShouldUseAttestation() || currentUser?.dsoName !== AttestationCode.BENEVIS) {
    return null;
  }

  return (
    <div className="card mt-2">
      <div className="card-body">
        <div
          style={{
            width: '100%',
            alignSelf: 'center',
            paddingInline: '5%',
          }}
        >
          <div className="card border-0" style={{ marginBottom: 30 }}>
            <h3 className="card-title" style={{ textAlign: 'center' }}>
              Benevis Attestation
            </h3>
          </div>
          <div
            style={{
              width: '100%',
              padding: '5px 10px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <p className="card-text" style={{ fontWeight: '600' }}>
              Allow Benevis Attestation:
            </p>
            {isLoading ? (
              <BootstrapSpinner
                animation="border"
                role="status"
                variant="info"
                style={{
                  height: 20,
                  width: 20,
                }}
              />
            ) : (
              <ReactSwitch
                checked={isEnabled}
                onChange={onToggle}
                onColor="#34C9EB"
                onHandleColor="#fff"
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0 0 1px 10px rgba(0, 0, 0, 0.2)"
                height={25}
                width={50}
                className="react-switch"
                id="material-switch"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
